/* ==========================================================================
   Lamp design reel
   --------------------------------------------------------------------------
   Turns each [data-lamp-reel] grid (sections/lamp-design-reel.liquid) into a
   full-screen vertical feed, Reels / TikTok style:

     - tap a photo and the feed opens on that lamp; every swipe (or wheel
       notch, or arrow key) snaps exactly one lamp up or down;
     - each slide has a caption, a heart (double-tap works too) and share;
     - one button on every slide, "See dates & book", with a line under it
       saying nothing is paid yet: people hesitate on a bare "Book now"
       when they can't tell whether it goes straight to payment. On a
       workshop page it closes the feed and scrolls to the booking calendar
       (#booking); anywhere else it links to the section's book URL (the
       mosaic workshop locations page);
     - the first time someone opens it, a hand shows the swipe and the next
       lamp peeks in, until their first swipe;
     - the phone's back button closes the feed rather than leaving the page;
     - ?lamp=<handle> in the URL opens the feed on that lamp, which is what
       the share button sends.

   The grid's order is already shuffled by the inline script in the section;
   the feed follows the grid's order, so the two always agree.

   Likes live only in this browser (localStorage). There is no server-side
   count, so the page never shows one.

   Analytics go to dataLayer and to Clarity as mas_lamp_reel_* events, the
   same shape as the booking widget's track(). Analytics must never break
   the page, so every call is wrapped.
   ========================================================================== */
(function () {
  'use strict';

  if (window.MasLampReel) return;

  var LIKES_KEY = 'mas_lamp_likes';
  var HINT_KEY = 'mas_lamp_reel_hint_seen';
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var REDUCED = mq('(prefers-reduced-motion: reduce)');

  /* ---- icons ------------------------------------------------------------ */
  var ICON = {
    heart: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path class="mlr-heart" d="M12 20.3s-7.4-4.6-9.2-9.1C1.6 8 3.4 4.6 6.8 4.3c2-.2 3.9.8 5.2 2.6 1.3-1.8 3.2-2.8 5.2-2.6 3.4.3 5.2 3.7 4 6.9-1.8 4.5-9.2 9.1-9.2 9.1z"/></svg>',
    heartSolid: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.4-4.6-9.2-9.1C1.6 8 3.4 4.6 6.8 4.3c2-.2 3.9.8 5.2 2.6 1.3-1.8 3.2-2.8 5.2-2.6 3.4.3 5.2 3.7 4 6.9-1.8 4.5-9.2 9.1-9.2 9.1z"/></svg>',
    share: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="M7.5 7.5 12 3l4.5 4.5"/><path d="M5 12.5V19a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6.5"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    up: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 15 6-6 6 6"/></svg>',
    down: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>',
    replay: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>',
    /* A hand with the index finger pointing up: the swipe gesture. */
    hand: '<svg viewBox="0 0 64 64" aria-hidden="true" focusable="false"><path fill="currentColor" stroke="rgba(0,0,0,.25)" stroke-width="1.5" stroke-linejoin="round" d="M26 8.5c0-2.5 2-4.5 4.5-4.5S35 6 35 8.5V29l1.2-.3c2.3-.6 4.5.8 5 3.1l.1.5 1.4-.3c2.3-.5 4.5 1 5 3.3l.1.6 1-.2c2.3-.4 4.5 1.1 4.9 3.4.1.4.1.8.1 1.2v9.1c0 7.8-6.3 14.1-14.1 14.1h-5.2c-4.7 0-9.1-2.3-11.7-6.2l-9.6-14c-1.4-2-.9-4.8 1.1-6.2 1.8-1.3 4.3-1 5.8.6l5.1 5.4z"/></svg>',
    mouse: '<svg viewBox="0 0 64 64" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round"><rect x="18" y="6" width="28" height="44" rx="14"/><path d="M32 15v9"/><path d="m24 57 8 5 8-5" stroke-linejoin="round"/></svg>'
  };

  /* ---- small helpers ---------------------------------------------------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function read(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function write(key, val) { try { window.localStorage.setItem(key, val); } catch (e) { /* private mode */ } }
  function getLikes() {
    try { var a = JSON.parse(read(LIKES_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function setLiked(handle, on) {
    var likes = getLikes().filter(function (h) { return h !== handle; });
    if (on) likes.push(handle);
    write(LIKES_KEY, JSON.stringify(likes.slice(-500)));
  }
  function clarity() {
    window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    return window.clarity;
  }
  function track(evt, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: evt };
      if (data) for (var k in data) payload[k] = data[k];
      window.dataLayer.push(payload);
    } catch (e) { /* analytics must never break the page */ }
    try { clarity()('event', 'mas_' + evt); } catch (e) { /* idem */ }
  }
  function tag(key, val) {
    try { clarity()('set', key, String(val)); } catch (e) { /* idem */ }
  }

  /* ---- one controller per section ---------------------------------------- */
  function Reel(root) {
    var self = this;
    this.root = root;
    this.items = [].slice.call(root.querySelectorAll('[data-mlr-tile]')).map(function (t) {
      return {
        handle: t.getAttribute('data-handle') || '',
        caption: t.getAttribute('data-caption') || '',
        alt: t.getAttribute('data-alt') || '',
        src: t.getAttribute('data-src') || '',
        srcset: t.getAttribute('data-srcset') || '',
        thumb: t.getAttribute('data-thumb') || '',
        video: t.getAttribute('data-video') || '',
        poster: t.getAttribute('data-poster') || ''
      };
    });
    if (!this.items.length) return;

    this.eyebrow = root.getAttribute('data-eyebrow') || '';
    this.bookLabel = root.getAttribute('data-book-label') || 'See dates & book';
    this.bookNote = root.getAttribute('data-book-note') || '';
    this.bookUrl = root.getAttribute('data-book-url') || '/pages/mosaic-workshop-locations-main-page';
    this.endTitle = root.getAttribute('data-end-title') || 'Your design is next';
    this.endText = root.getAttribute('data-end-text') || '';
    this.el = null;
    this.index = 0;
    this.isOpen = false;
    this.pushed = false;
    this.maxSeen = 0;
    this.swiped = false;
    this.endTracked = false;

    root.addEventListener('click', function (e) {
      var tileBtn = e.target.closest('[data-mlr-open]');
      if (tileBtn) {
        var tile = tileBtn.closest('[data-mlr-tile]');
        var tiles = [].slice.call(root.querySelectorAll('[data-mlr-tile]'));
        self.open(Math.max(0, tiles.indexOf(tile)), 'tile', tileBtn);
        return;
      }
      var all = e.target.closest('[data-mlr-all]');
      if (all) self.open(0, 'see_all', all);
    });

    this.onPop = function () { if (self.isOpen) self.finishClose(); };
    window.addEventListener('popstate', this.onPop);

    // Shared link: ?lamp=<handle> opens the feed on that lamp.
    if (!(window.Shopify && window.Shopify.designMode)) {
      var wanted = null;
      try { wanted = new URLSearchParams(window.location.search).get('lamp'); } catch (e) { /* old browser */ }
      if (wanted) {
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].handle === wanted) {
            try {
              var url = new URL(window.location.href);
              url.searchParams.delete('lamp');
              history.replaceState(history.state, '', url.toString());
            } catch (e) { /* keep the param; harmless */ }
            this.open(i, 'shared_link');
            break;
          }
        }
      }
    }
  }

  /* Total slides = lamps + the end card. */
  Reel.prototype.count = function () { return this.items.length + 1; };

  Reel.prototype.build = function () {
    var self = this;
    var n = this.items.length;
    var likes = getLikes();
    var touch = !mq('(hover: hover) and (pointer: fine)');

    var slides = this.items.map(function (it, i) {
      var liked = likes.indexOf(it.handle) !== -1;
      var media = it.video
        ? '<video class="mlr-slide__media" data-src="' + esc(it.video) + '"' + (it.poster ? ' poster="' + esc(it.poster) + '"' : '') + ' muted loop playsinline preload="none" aria-label="' + esc(it.alt) + '"></video>'
        : '<img class="mlr-slide__media" alt="' + esc(it.alt) + '" data-src="' + esc(it.src) + '" data-srcset="' + esc(it.srcset) + '" decoding="async" draggable="false">';
      return '' +
        '<section class="mlr-slide" data-i="' + i + '" role="group" aria-roledescription="slide" aria-label="' + (i + 1) + ' of ' + n + '">' +
          '<div class="mlr-slide__bg" data-bg="' + esc(it.thumb) + '"></div>' +
          media +
          '<div class="mlr-slide__meta">' +
            (self.eyebrow ? '<p class="mlr-slide__eyebrow">' + esc(self.eyebrow) + '</p>' : '') +
            (it.caption ? '<p class="mlr-slide__caption">' + esc(it.caption) + '</p>' : '') +
          '</div>' +
          '<div class="mlr-slide__rail">' +
            '<button type="button" class="mlr-act" data-mlr-like aria-pressed="' + liked + '" aria-label="Like this design">' +
              '<span class="mlr-act__ico">' + ICON.heart + '</span><span>Like</span></button>' +
            '<button type="button" class="mlr-act" data-mlr-share aria-label="Share this design">' +
              '<span class="mlr-act__ico">' + ICON.share + '</span><span>Share</span></button>' +
          '</div>' +
        '</section>';
    }).join('');

    var mosaic = this.items.slice(0, 9).map(function (it) {
      return '<span style="background-image:url(&quot;' + esc(it.thumb.replace(/width=\d+/, 'width=240')) + '&quot;)"></span>';
    }).join('');

    var end = '' +
      '<section class="mlr-slide mlr-slide--end" data-i="' + n + '" role="group" aria-roledescription="slide" aria-label="The end">' +
        '<div class="mlr-end__mosaic" aria-hidden="true">' + mosaic + '</div>' +
        '<div class="mlr-end__body">' +
          '<p class="mlr-end__eyebrow">That was all ' + n + ' designs</p>' +
          '<h2 class="mlr-end__title">' + esc(this.endTitle) + '</h2>' +
          (this.endText ? '<p class="mlr-end__text">' + esc(this.endText) + '</p>' : '') +
          '<div class="mlr-end__actions">' +
            '<a class="mlr-btn mlr-btn--primary" href="' + esc(this.bookUrl) + '" data-mlr-book="end">' + esc(this.bookLabel) + '</a>' +
            (this.bookNote ? '<p class="mlr-note">' + esc(this.bookNote) + '</p>' : '') +
            '<button type="button" class="mlr-btn mlr-btn--ghost mlr-btn--on-dark" data-mlr-again>' + ICON.replay + 'Watch again</button>' +
          '</div>' +
        '</div>' +
      '</section>';

    var hintText = touch ? 'Swipe up for more designs' : 'Scroll or use ↑ ↓ for more designs';

    var el = document.createElement('div');
    el.className = 'mlr-reel mas-ws';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Lamp designs');
    el.innerHTML = '' +
      '<div class="mlr-reel__backdrop" aria-hidden="true"></div>' +
      '<div class="mlr-reel__stage">' +
        '<div class="mlr-reel__track" tabindex="-1">' + slides + end + '</div>' +
        '<div class="mlr-reel__top">' +
          '<span class="mlr-progress" aria-hidden="true"><span class="mlr-progress__bar"></span></span>' +
          '<span class="mlr-count" aria-live="polite"></span>' +
          '<button type="button" class="mlr-close" data-mlr-close aria-label="Close">' + ICON.close + '</button>' +
        '</div>' +
        '<div class="mlr-hint" aria-hidden="true">' +
          '<span class="mlr-hint__hand">' + (touch ? ICON.hand : ICON.mouse) + '</span>' +
          '<p class="mlr-hint__text">' + hintText + '</p>' +
        '</div>' +
        '<div class="mlr-reel__bottom">' +
          '<a class="mlr-btn mlr-btn--primary" href="' + esc(this.bookUrl) + '" data-mlr-book="slide">' + esc(this.bookLabel) + '</a>' +
          (this.bookNote ? '<p class="mlr-note">' + esc(this.bookNote) + '</p>' : '') +
        '</div>' +
        '<div class="mlr-toast" role="status" aria-live="polite"></div>' +
      '</div>' +
      '<div class="mlr-reel__nav">' +
        '<button type="button" class="mlr-navbtn" data-mlr-prev aria-label="Previous design">' + ICON.up + '</button>' +
        '<button type="button" class="mlr-navbtn" data-mlr-next aria-label="Next design">' + ICON.down + '</button>' +
      '</div>';

    document.body.appendChild(el);
    this.el = el;
    this.track_ = el.querySelector('.mlr-reel__track');
    this.slides = [].slice.call(el.querySelectorAll('.mlr-slide'));
    this.countEl = el.querySelector('.mlr-count');
    this.barEl = el.querySelector('.mlr-progress__bar');
    this.backdrop = el.querySelector('.mlr-reel__backdrop');
    this.toastEl = el.querySelector('.mlr-toast');
    this.prevBtn = el.querySelector('[data-mlr-prev]');
    this.nextBtn = el.querySelector('[data-mlr-next]');
    this.bindReel();
  };

  Reel.prototype.bindReel = function () {
    var self = this;
    var el = this.el;
    var track = this.track_;

    // Which slide is in view. Rounded scroll position is exact with snapping,
    // and cheaper than an IntersectionObserver per slide; setIndex only runs
    // when the slide actually changes.
    track.addEventListener('scroll', function () {
      var h = track.clientHeight || 1;
      var i = Math.round(track.scrollTop / h);
      if (i !== self.index) self.setIndex(i, true);
    }, { passive: true });

    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-mlr-close]')) { self.close(); return; }
      if (t.closest('[data-mlr-prev]')) { self.go(-1); return; }
      if (t.closest('[data-mlr-next]')) { self.go(1); return; }
      if (t.closest('[data-mlr-again]')) { self.again(); return; }
      var like = t.closest('[data-mlr-like]');
      if (like) { self.toggleLike(like); return; }
      if (t.closest('[data-mlr-share]')) { self.share(); return; }
      var book = t.closest('[data-mlr-book]');
      if (book) { self.book(e, book.getAttribute('data-mlr-book')); return; }
      // A click on the blurred backdrop beside the desktop column closes.
      if (t === el || t === self.backdrop) self.close();
    });

    // Double-tap (or double-click) a photo to like it, with a heart where it landed.
    var down = null;
    var lastTap = null;
    track.addEventListener('pointerdown', function (e) {
      down = { x: e.clientX, y: e.clientY, i: self.index };
    });
    track.addEventListener('pointerup', function (e) {
      if (!down) return;
      var moved = Math.abs(e.clientX - down.x) > 12 || Math.abs(e.clientY - down.y) > 12;
      var start = down;
      down = null;
      if (moved || start.i !== self.index || e.target.closest('button, a')) { lastTap = null; return; }
      var slide = e.target.closest('.mlr-slide');
      if (!slide || slide.classList.contains('mlr-slide--end')) return;
      var now = Date.now();
      if (lastTap && now - lastTap.t < 320 && Math.abs(e.clientX - lastTap.x) < 40 && Math.abs(e.clientY - lastTap.y) < 40) {
        lastTap = null;
        self.burst(slide, e.clientX, e.clientY);
        var btn = slide.querySelector('[data-mlr-like]');
        if (btn && btn.getAttribute('aria-pressed') !== 'true') self.toggleLike(btn, 'double_tap');
      } else {
        lastTap = { t: now, x: e.clientX, y: e.clientY };
      }
    });

    // Wheel and trackpad: one lamp per gesture. Left alone, a trackpad flick
    // keeps sending inertia events for a second or more and would race
    // through several lamps.
    var lastWheel = 0;
    var lastStep = 0;
    el.addEventListener('wheel', function (e) {
      e.preventDefault();
      var now = Date.now();
      var quietBefore = now - lastWheel;
      lastWheel = now;
      if (Math.abs(e.deltaY) < 4) return;
      if (quietBefore > 160 || now - lastStep > 900) {
        if (now - lastStep < 380) return;
        lastStep = now;
        self.go(e.deltaY > 0 ? 1 : -1);
      }
    }, { passive: false });

    el.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'Escape') { e.preventDefault(); self.close(); return; }
      if (k === 'Tab') { self.trapFocus(e); return; }
      var onButton = e.target.closest && e.target.closest('button, a');
      if (k === 'ArrowDown' || k === 'PageDown' || k === 'j' || (k === ' ' && !onButton && !e.shiftKey)) { e.preventDefault(); self.go(1); }
      else if (k === 'ArrowUp' || k === 'PageUp' || k === 'k' || (k === ' ' && !onButton && e.shiftKey)) { e.preventDefault(); self.go(-1); }
      else if (k === 'Home') { e.preventDefault(); self.goTo(0); }
      else if (k === 'End') { e.preventDefault(); self.goTo(self.count() - 1); }
    });

    // Keep the current lamp snapped after a rotation or window resize.
    var resizeT = null;
    this.onResize = function () {
      if (!self.isOpen) return;
      window.clearTimeout(resizeT);
      resizeT = window.setTimeout(function () {
        track.scrollTo({ top: self.index * track.clientHeight, behavior: 'auto' });
      }, 120);
    };
    window.addEventListener('resize', this.onResize);
  };

  Reel.prototype.open = function (i, source, opener) {
    if (this.isOpen) return;
    if (!this.el) this.build();
    this.opener = opener || document.activeElement;
    this.isOpen = true;
    this.swiped = false;
    this.endTracked = false;
    this.openedAt = i;
    this.maxSeen = i;

    document.documentElement.classList.add('mlr-lock');
    this.el.hidden = false;
    // Position before the fade-in, so the feed never flashes slide 1.
    this.track_.scrollTo({ top: i * this.track_.clientHeight, behavior: 'auto' });
    this.setIndex(i, false);
    void this.el.offsetWidth; // commit the hidden -> shown state so the fade-in runs
    this.el.classList.add('is-open');

    try { history.pushState({ mlr: true }, ''); this.pushed = true; } catch (e) { this.pushed = false; }

    this.track_.focus({ preventScroll: true });
    if (read(HINT_KEY) !== '1') this.showHint();

    track('lamp_reel_open', { source: source, lamp: (this.items[i] || {}).handle, position: i + 1, total: this.items.length });
    tag('lamp_reel', 'opened');
  };

  /* Close from the UI. With a history entry pushed, going back is what closes
     it (popstate -> finishClose), so the back button and the X agree. */
  Reel.prototype.close = function () {
    if (!this.isOpen) return;
    if (this.pushed && history.state && history.state.mlr) { history.back(); return; }
    this.finishClose();
  };

  Reel.prototype.finishClose = function () {
    if (!this.isOpen) return;
    var self = this;
    this.isOpen = false;
    this.pushed = false;
    this.hideHint(false);
    this.pauseAll();
    this.el.classList.remove('is-open');
    document.documentElement.classList.remove('mlr-lock');
    window.setTimeout(function () { if (!self.isOpen) self.el.hidden = true; }, REDUCED ? 0 : 200);
    track('lamp_reel_close', { seen: this.maxSeen + 1, total: this.items.length });
    tag('lamp_reel_depth', this.depthBucket());
    if (this.opener && this.opener.focus && document.contains(this.opener)) {
      try { this.opener.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
    if (this.afterClose) { var fn = this.afterClose; this.afterClose = null; window.setTimeout(fn, 30); }
  };

  /* How far people got, as a Clarity tag: the exact number stays in dataLayer. */
  Reel.prototype.depthBucket = function () {
    var seen = this.maxSeen + 1;
    if (this.maxSeen >= this.items.length) return 'end';
    if (seen <= 1) return '1';
    if (seen <= 5) return '2-5';
    if (seen <= 15) return '6-15';
    return '16+';
  };

  Reel.prototype.goTo = function (i) {
    var last = this.count() - 1;
    i = Math.max(0, Math.min(last, i));
    this.track_.scrollTo({ top: i * this.track_.clientHeight, behavior: REDUCED ? 'auto' : 'smooth' });
  };
  Reel.prototype.go = function (delta) { this.goTo(this.index + delta); };

  Reel.prototype.again = function () {
    track('lamp_reel_watch_again');
    this.goTo(0);
  };

  Reel.prototype.setIndex = function (i, byUser) {
    var n = this.items.length;
    i = Math.max(0, Math.min(n, i));
    this.index = i;
    if (i > this.maxSeen) this.maxSeen = i;

    var isEnd = i === n;
    this.el.classList.toggle('is-end', isEnd);
    this.countEl.textContent = isEnd ? n + ' / ' + n : (i + 1) + ' / ' + n;
    this.barEl.style.width = (Math.min(i + 1, n) / n * 100) + '%';
    if (this.prevBtn) this.prevBtn.disabled = i === 0;
    if (this.nextBtn) this.nextBtn.disabled = isEnd;

    // Only the slide in view takes focus and clicks; the rest are inert, which
    // also keeps Tab inside the slide the person is looking at.
    this.slides.forEach(function (s, k) {
      var off = k !== i;
      s.inert = off;
      if (off) s.setAttribute('aria-hidden', 'true'); else s.removeAttribute('aria-hidden');
    });

    for (var k = i - 1; k <= i + 2; k++) this.load(k);
    if (!isEnd && this.items[i]) this.backdrop.style.backgroundImage = 'url("' + this.items[i].thumb.replace(/width=\d+/, 'width=200') + '")';
    this.playCurrent();

    if (byUser) {
      if (i !== this.openedAt) this.hideHint(true);
      if (!this.swiped && i !== this.openedAt) {
        this.swiped = true;
        track('lamp_reel_swipe');
      }
      if (isEnd && !this.endTracked) {
        this.endTracked = true;
        track('lamp_reel_end', { total: n });
      }
    }
    if (this.hinting) this.nudge();
  };

  /* Lazy-load a slide's photo (or video) and its blurred backdrop. */
  Reel.prototype.load = function (k) {
    var s = this.slides && this.slides[k];
    if (!s || s.getAttribute('data-loaded')) return;
    s.setAttribute('data-loaded', '1');
    var bg = s.querySelector('.mlr-slide__bg');
    if (bg && bg.getAttribute('data-bg')) bg.style.backgroundImage = 'url("' + bg.getAttribute('data-bg') + '")';
    var m = s.querySelector('.mlr-slide__media');
    if (!m) return;
    var done = function () { m.classList.add('is-loaded'); };
    if (m.tagName === 'VIDEO') {
      m.addEventListener('loadeddata', done, { once: true });
      if (m.poster) done();
      m.src = m.getAttribute('data-src');
      m.preload = 'auto';
    } else {
      m.addEventListener('load', done, { once: true });
      m.addEventListener('error', done, { once: true });
      m.sizes = '(min-width: 768px) calc((100vh - 48px) * 9 / 16), 100vw';
      if (m.getAttribute('data-srcset')) m.srcset = m.getAttribute('data-srcset');
      m.src = m.getAttribute('data-src');
      if (m.complete && m.naturalWidth) done();
    }
  };

  Reel.prototype.playCurrent = function () {
    var cur = this.slides[this.index];
    this.slides.forEach(function (s) {
      var v = s.querySelector('video');
      if (!v) return;
      if (s === cur) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  };
  Reel.prototype.pauseAll = function () {
    (this.slides || []).forEach(function (s) { var v = s.querySelector('video'); if (v) v.pause(); });
  };

  Reel.prototype.showHint = function () {
    this.hinting = true;
    this.el.classList.add('is-hinting');
    this.nudge();
  };
  Reel.prototype.nudge = function () {
    var i = this.index;
    this.slides.forEach(function (s, k) { s.classList.toggle('is-nudge', k === i || k === i + 1); });
  };
  /* seen = the person actually swiped, so the hint has done its job. */
  Reel.prototype.hideHint = function (seen) {
    if (!this.hinting) return;
    this.hinting = false;
    if (this.el) {
      this.el.classList.remove('is-hinting');
      this.slides.forEach(function (s) { s.classList.remove('is-nudge'); });
    }
    if (seen) write(HINT_KEY, '1');
  };

  Reel.prototype.toggleLike = function (btn, how) {
    var slide = btn.closest('.mlr-slide');
    var item = this.items[parseInt(slide.getAttribute('data-i'), 10)];
    if (!item) return;
    var on = btn.getAttribute('aria-pressed') !== 'true';
    btn.setAttribute('aria-pressed', String(on));
    setLiked(item.handle, on);
    track(on ? 'lamp_reel_like' : 'lamp_reel_unlike', { lamp: item.handle, how: how || 'button' });
  };

  Reel.prototype.burst = function (slide, x, y) {
    var r = slide.getBoundingClientRect();
    var b = document.createElement('span');
    b.className = 'mlr-burst';
    b.style.left = (x - r.left) + 'px';
    b.style.top = (y - r.top) + 'px';
    b.innerHTML = ICON.heartSolid;
    slide.appendChild(b);
    window.setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 900);
  };

  Reel.prototype.shareUrl = function (item) {
    try {
      var url = new URL(window.location.origin + window.location.pathname);
      url.searchParams.set('lamp', item.handle);
      return url.toString();
    } catch (e) {
      return window.location.origin + window.location.pathname + '?lamp=' + encodeURIComponent(item.handle);
    }
  };

  Reel.prototype.share = function () {
    var self = this;
    var item = this.items[this.index];
    if (!item) return;
    var url = this.shareUrl(item);
    var data = { title: 'A mosaic lamp made at Mosaic Art Studio', text: item.caption || 'A mosaic lamp made by a guest at Mosaic Art Studio', url: url };
    if (navigator.share) {
      navigator.share(data).then(function () {
        track('lamp_reel_share', { lamp: item.handle, how: 'native' });
      }).catch(function () { /* cancelled */ });
      return;
    }
    var copied = function () {
      self.toast('Link copied');
      track('lamp_reel_share', { lamp: item.handle, how: 'copy' });
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(copied, function () { self.copyFallback(url) ? copied() : self.toast('Could not copy the link'); });
    } else if (this.copyFallback(url)) {
      copied();
    } else {
      this.toast('Could not copy the link');
    }
  };
  Reel.prototype.copyFallback = function (text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
      this.el.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      this.el.removeChild(ta);
      return ok;
    } catch (e) { return false; }
  };

  Reel.prototype.toast = function (msg) {
    var t = this.toastEl;
    t.textContent = msg;
    t.classList.add('is-show');
    window.clearTimeout(this.toastT);
    this.toastT = window.setTimeout(function () { t.classList.remove('is-show'); }, 1800);
  };

  /* On a workshop page the booking widget is right there: close and scroll to
     it. Anywhere else, Book is an ordinary link and the browser follows it. */
  Reel.prototype.book = function (e, where) {
    var item = this.items[this.index];
    var target = document.getElementById('booking');
    track('lamp_reel_book', { lamp: item ? item.handle : 'end', where: where, action: target ? 'scroll' : 'link' });
    try { clarity()('upgrade', 'lamp_reel_book'); } catch (err) { /* ignore */ }
    if (!target) return;
    e.preventDefault();
    this.afterClose = function () {
      target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    };
    this.close();
  };

  Reel.prototype.trapFocus = function (e) {
    var list = [].slice.call(this.el.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (n) { return !n.closest('[inert]') && n.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !this.el.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  Reel.prototype.destroy = function () {
    if (this.isOpen) this.finishClose();
    window.removeEventListener('popstate', this.onPop);
    if (this.onResize) window.removeEventListener('resize', this.onResize);
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
    this.el = null;
  };

  /* ---- boot ---------------------------------------------------------------- */
  function init(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-lamp-reel]')).forEach(function (root) {
      if (root.mlrReel) return;
      root.mlrReel = new Reel(root);
    });
  }

  window.MasLampReel = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor: sections are re-rendered in place.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].slice.call(e.target.querySelectorAll('[data-lamp-reel]')).forEach(function (root) {
      if (root.mlrReel && root.mlrReel.destroy) root.mlrReel.destroy();
      root.mlrReel = null;
    });
  });
})();
